"use client";

import styles from "@/components/common/styles/upload-drag-and-drop.module.scss";
import Image from "next/image";
import uploadIcon from "@/assets/convert/upload.svg";
import React, { useState } from "react";

type UploadDragAndDropProps = {
  handleFilesAdded: (files: File[]) => void;
  acceptedFiles: string;
  topText: string;
  bottomText: string;
  isActive: boolean;
  isMultiple?: boolean;
};

const UploadDragAndDrop = ({
  handleFilesAdded,
  acceptedFiles,
  topText,
  bottomText,
  isActive,
  isMultiple = true,
}: UploadDragAndDropProps) => {
  const [dragging, setDragging] = useState(false);

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  return (
    <div className={styles.wrapper}>
      <label>
        <input
          type="file"
          disabled={!isActive}
          multiple={isMultiple}
          onChange={(e) => handleFilesAdded(Array.from(e.target.files ?? []))}
          className={styles.input}
          accept={acceptedFiles}
        />
        <div
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={(e) => {
            e.preventDefault();
            if (isActive) {
              handleFilesAdded(Array.from(e.dataTransfer.files));
            }
          }}
          className={styles.drag_and_drop_wrapper}
        >
          <Image className={styles.upload_icon} src={uploadIcon} alt="Upload" />
          <div className={styles.text_wrapper}>
            <div className={styles.upload_title}>{topText}</div>
            <div className={styles.upload_description}>{bottomText}</div>
          </div>
        </div>
      </label>
    </div>
  );
};

export default UploadDragAndDrop;
